import { render } from "./MailTable.vue?vue&type=template&id=617f5419&scoped=true"
import script from "./MailTable.vue?vue&type=script&lang=js"
export * from "./MailTable.vue?vue&type=script&lang=js"

import "./MailTable.vue?vue&type=style&index=0&id=617f5419&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-617f5419"

export default script